/**
 * SheetJS wird erst geholt, wenn wirklich eine Excel-Datei gelesen oder
 * geschrieben wird.
 *
 * Fest eingebunden lag die Bibliothek im Startbuendel: Jedes Geraet lud sie
 * beim ersten Aufruf der App mit, auch wer nie etwas importiert oder
 * exportiert. Der Import ist ohnehin ein Weg, den man bewusst geht, und jeder
 * Schritt darin wartet schon auf etwas (Datei oeffnen, lesen) - die Ladezeit
 * faellt dort nicht auf.
 *
 * Das Ergebnis wird als Versprechen gemerkt, nicht als Modul: So holt auch ein
 * zweiter Aufruf, der startet, waehrend der erste noch laedt, die Bibliothek
 * nicht ein zweites Mal.
 */
let geladen: Promise<typeof import('xlsx')> | null = null;

export function ladeXlsx(): Promise<typeof import('xlsx')> {
	// SheetJS kommt als CommonJS-Paket. Je nach Bau liegt der Inhalt direkt im
	// Modul oder unter `default` - beides abfangen, sonst waere `read` mal da
	// und mal nicht.
	if (!geladen) {
		geladen = import('xlsx').then(m => ((m as any).default ?? m) as typeof import('xlsx'));
	}
	return geladen;
}
